module.exports = __webpack_public_path__ + "static/media/Image_OB_Standby.43abee6f.png";